import { useV2GetQuestionnaireByIdQuery, V2QuestionResource } from "@generated";
import { Questionnaire } from "../types";

// v2 splits v1's `position` in two: `position` is now the order within a
// section, and `questionnaire-position` carries the questionnaire-wide order
// that v1 returned as `position`.
const questionnaireOrder = (question: V2QuestionResource) =>
  question?.attributes?.["questionnaire-position"] ??
  question?.attributes?.position ??
  0;

const useGetQuestionnaire = (id) => {
  const { data, isLoading } = useV2GetQuestionnaireByIdQuery({
    id,
    include: ["account", "questions"],
  });

  let questionnaire: Questionnaire | null = null;

  const questions =
    (data?.included?.filter(
      //@ts-ignore
      (item) => item.type === "questions" && item?.attributes?.active
    ) as V2QuestionResource[]) || [];

  if (data?.data) {
    questionnaire = {
      id: String(data.data.id),
      name: data.data?.attributes?.name || "",
      introduction: data.data?.attributes?.introduction || "",
      questions: questions
        .sort((a, b) => questionnaireOrder(a) - questionnaireOrder(b))
        .map((question) => {
          return {
            ...question.attributes,
            "question-id": question?.id ? Number(question.id) : undefined,
            "questionnaire-section-id": data.data?.attributes?.questions?.find(
              //@ts-ignore
              (q) => q?.id == question.id
            )?.["questionnaire-section-id"],
          };
        }),
      sections: data?.data?.attributes?.sections || [],
    };
  }
  return { questionnaire, questionnaireLoading: isLoading };
};

export default useGetQuestionnaire;
